module.exports = __webpack_public_path__ + "static/img/banner.c25c913f.png";